import React from "react";
import { Button, NewTab, PageTab } from "../../../components";
import { useNavigate } from "react-router-dom";
import DocumentSettings from "./Documents/DocumentSettings";

const Documents = () => {
  const navigate = useNavigate();
  const documentsMenus = [
    {
      title: "Applicants",
      page: <DocumentSettings documentType={1} />,
      type: "main",
    },
    {
      title: "Vendors",
      page: <DocumentSettings documentType={2} />,
      type: "main",
    },
    {
      title: "Clients",
      page: <DocumentSettings documentType={3} />,
      type: "main",
    },
  ];
  return (
    <div className="flex flex-col gap-3">
      <Button
        title={"Back"}
        icon={"west"}
        variant="text"
        color="black"
        className="!self-start font-semibold !px-1"
        onClick={() => navigate("/e-onboarding#dashboard")}
      />
      <NewTab
        tabs={documentsMenus}
        color="black"
        variant="outlined"
        mode="url"
        tabId="documents"
      />
    </div>
  );
};

export default Documents;
